import { render } from "./AiServiceView.vue?vue&type=template&id=34a7588b&scoped=true"
import script from "./AiServiceView.vue?vue&type=script&lang=js"
export * from "./AiServiceView.vue?vue&type=script&lang=js"

import "./AiServiceView.vue?vue&type=style&index=0&id=34a7588b&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34a7588b"]])

export default __exports__